<template>
  <div class="media-uploader">
    <div class="uploader-content fit-content overflow-auto bg-dashboard-dark-1">
      <div class="media-header bg-dashboard-dark-1">
        <div>
          <h1
            class="d-flex justify-content-start align-items-center text-white"
          >
            <span>Select date</span>
            <span class="ml-1" v-if="isRange">range</span>
          </h1>
        </div>
        <button
          class="btn-close bg-dark text-light"
          @click="close"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Close"
        >
          &times;
        </button>
      </div>
      <div class="media-container px-4 pb-4 overflow-hidden">
        <button
          class="btn btn-link btn-sm my-2 float-right"
          @click="dateInputChange(false)"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Clear date"
        >
          Clear date
        </button>
        <div class="clearfix"></div>
        <v-date-picker
          is-dark
          class="d-block mx-auto"
          :value="selectedDate"
          mode="date"
          trim-weeks
          :is-range="isRange || false"
          @input="dateInputChange"
        />
      </div>
      <div class="media-footer bg-dashboard-dark-1 border-outline-dark-top">
        <button
          class="btn btn-outline-light btn-sm"
          @click="close"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Click to cancel"
        >
          Cancel
        </button>
        <button
          class="btn btn-info btn-sm"
          @click="dateSelected"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Click to apply"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Helper from "@/helper";

export default {
  name: "media-uploader",
  props: ["dateRange", "isRange"],
  data() {
    return {
      selectedDate: null,
      helper: Helper,
    };
  },
  methods: {
    dateInputChange(e) {
      this.selectedDate = e;
    },
    dateSelected() {
      if (this.selectedDate === null) {
        Swal.fire("", "Please select start & end date", "warning");
      } else {
        this.$emit("close", this.selectedDate);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.selectedDate = this.dateRange;
  },
};
</script>